import {Map, fromJS} from 'immutable';

const defaultState = Map({
    helpdesk: Map({
        feedback: Map(),
        questions: Map()
    }),
    currentItem: null
})

function reducer( state=defaultState, action) {
    switch (action.type) {
        case 'V2/HELP_DESK_FEEDBACK':
            state = state.setIn(['helpdesk', 'feedback'], fromJS(action.payload))
            return state
        case 'V2/HELP_DESK_FEEDBACK_QUESTIONS':
            state = state.setIn(['helpdesk', 'questions'], fromJS(action.payload))
            return state
        case 'set current feedback':
            state = state.set('currentItem', fromJS(action.payload))
        default:
            return state
      }
}

export default reducer



// WEBPACK FOOTER //
// ./src/model/Feedback/reducer.js